import { createApi } from '@reduxjs/toolkit/query/react';

import { baseQueryWithReauth } from './baseQuery';
import { TAGS } from './tags';

export type TagTypes = Array<(typeof TAGS)[keyof typeof TAGS]>;

export const baseApi = createApi({
  baseQuery: baseQueryWithReauth,
  reducerPath: 'baseApi',
  keepUnusedDataFor: 0,
  tagTypes: Object.values(TAGS),
  endpoints: () => ({}),
});
